<template>
  <el-popover
    placement="left"
    :title="$t('login.pswValidatePopover.title')"
    width="296"
    trigger="manual"
    :value="popoverValue"
  >
    <ul class="rules">
      <li class="rule">
        <i class="el-icon-success" :class="{ 'pass': validate.rule1 }"></i>
        <p>{{ $t('login.pswValidatePopover.rule1') }}</p>
      </li>
      <li class="rule">
        <i class="el-icon-success" :class="{ 'pass': validate.rule2 }"></i>
        <p>{{ $t('login.pswValidatePopover.rule2') }}</p>
      </li>
      <li class="rule">
        <i class="el-icon-success" :class="{ 'pass': validate.rule3 }"></i>
        <p>{{ $t('login.pswValidatePopover.rule3') }}</p>
      </li>
      <li class="rule">
        <i class="el-icon-success" :class="{ 'pass': validate.rule4 }"></i>
        <p>{{ $t('login.pswValidatePopover.rule4') }}</p>
      </li>
    </ul>
    <template slot="reference">
      <slot></slot>
    </template>
  </el-popover>
</template>

<script>
import {
  PORTAL_PASSWORD_LENGTH,
  PORTAL_PASSWORD_UPPER,
  PORTAL_PASSWORD_LOWER,
  PORTAL_PASSWORD_DIGIT_AND_SPECIAL,
} from '@/utils/portalPasswordRules'

export default {
  data() {
    return {
      validate: {
        rule1: false,
        rule2: false,
        rule3: false,
        rule4: false
      },
      childInstance: null,
      popoverValue: false,
    }
  },
  watch: {
    "childInstance.value": function (newV) {
      this.validate.rule1 = PORTAL_PASSWORD_LENGTH.test(newV)
      this.validate.rule2 = PORTAL_PASSWORD_UPPER.test(newV)
      this.validate.rule3 = PORTAL_PASSWORD_LOWER.test(newV)
      this.validate.rule4 = PORTAL_PASSWORD_DIGIT_AND_SPECIAL.test(newV)
    
      const allValid = this.validate.rule1 && this.validate.rule2 && this.validate.rule3 && this.validate.rule4
      this.popoverValue = !allValid && newV.length > 0
    }
  },
  mounted() {
    this.childInstance = this.$slots.default[0].componentInstance;
  }
}
</script>

<style scoped lang="scss">
.rules {
  .rule {
    display: flex;
    align-items: center;
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .el-icon-success.pass {
      color: #0acc8b
    }

    p {
      margin-left: 9px;
    }
  }
}
</style>
